export const STATUS_COLORS = {
  pending: "#ed6c02",
  confirmed: "#2e7d32",
  in_progress: "#0288d1",
  completed: "#66bb6a",
  cancelled: "#d32f2f",
  no_show: "#9e9e9e",
  rescheduled: "#7b1fa2"
};
